import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { HttpStatusService } from '../../services/http-status/http-status.service'

@Component({
  selector: 'gpei-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.sass'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class SpinnerComponent {
  constructor(public httpStatus: HttpStatusService) { }
}
